import { render, staticRenderFns } from "./PatrolDetail.vue?vue&type=template&id=665489ee&scoped=true"
import script from "./PatrolDetail.vue?vue&type=script&lang=js"
export * from "./PatrolDetail.vue?vue&type=script&lang=js"
import style0 from "./PatrolDetail.vue?vue&type=style&index=0&id=665489ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665489ee",
  null
  
)

export default component.exports